<div class="body">
  <div class="snow">
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
  </div>
  <div id="tid-bar">
    <marquee i18n="Disclaimer in the top-bar@@app.topBarDisclaimer">This is a fan-made website. We are not related to Motion Twin (the creators of Hammerfest).</marquee>
  </div>
  <header>
    <div class="img-rays">
      <svg width="630px" height="315px" viewBox="-256 -256 512 256">
        <defs>
          <path id="header-ray" d="M0,0 -69,-500 69,-500 z"></path>
        </defs>
        <g id="header-rays">
          <use xlink:href="#header-ray" transform="rotate(21) scale(1.3, 1)"></use>
          <use xlink:href="#header-ray" transform="rotate(51) scale(0.9, 1)"></use>
          <use xlink:href="#header-ray" transform="rotate(72) scale(0.7, 1)"></use>
          <use xlink:href="#header-ray" transform="rotate(-21) scale(1.3, 1)"></use>
          <use xlink:href="#header-ray" transform="rotate(-51) scale(0.9, 1)"></use>
          <use xlink:href="#header-ray" transform="rotate(-72) scale(0.7, 1)"></use>
        </g>
      </svg>
      <div class="grad"></div>
    </div>
    <div class="img-main-bar"></div>
    <div class="img-snow"></div>
    <div class="img-title"></div>
    <div class="img-left"></div>
    <div class="img-right"></div>
    <div class="img-expansion-dimensions"></div>
    <h1><a routerLink="/" i18n="Header title@@app.headerTitle">The caverns of Hammerfest - The parallel dimensions</a></h1>
    <div class="main-bar">
      <nav>
        @if (isAuthenticated$ | async) {
          <div>
            <a routerLink="/users/{{userId$ | async}}">{{userDisplayName$ | async}}</a>
          </div>
        } @else {
          <a class="button" routerLink="/login" i18n="Button to the login page@@app.loginNav">Login</a>
        }
      </nav>
      <button (click)="toggleSnow()" id="toggle-snow">❄</button>
    </div>
  </header>
  <div class="content">
    <nav class="main-nav">
      <a
        class="game-hfest"
        routerLink="/games/hammerfest"
        i18n-title="Title of the &quot;Hammerfest&quot; game page button@@app.gameHfestNav.title"
        title="Play Hammerfest"
        i18n="Link to the &quot;Hammerfest&quot; game page@@app.gameHfestNav"
      >Play Hammerfest</a>
      <a
        class="games"
        routerLink="/games"
        i18n-title="Title of the &quot;Games&quot; page button@@app.gamesNav.title"
        title="Play Eternalfest"
        i18n="Link to the &quot;Games&quot; page@@app.gamesNav"
      >Play Eternalfest</a>
      @if (isAuthenticated$ | async) {
        <a
          class="settings"
          routerLink="/settings"
          i18n-title="Title of the &quot;Settings&quot; page button@@app.settingsNav.title"
          title="Settings"
          i18n="Link to the &quot;Settings&quot; page@@app.settingsNav"
        >Settings</a>
        <form
          class="logout"
          action="/actions/logout"
          enctype="application/x-www-form-urlencoded"
          method="POST"
          >
          <input
            type="submit"
            i18n-value="Name of the logout button@@app.logout"
            value="Logout"
            i18n-title="Title of the logout button@@app.logout.title"
            title="Logout"
            />
        </form>
      }
    </nav>
    <router-outlet></router-outlet>
  </div>
  <footer>
    <div>
      <div class="img-back"></div>
    </div>
    <div class="img-front"></div>
    <div class="wrapper">
      <p>Eternalfest 2013-2025</p>
      <div class="languages">
        <span class="flag" title="Deutsch">
          <a lang="de-DE" href="/?l=de">Deutsch</a>
        </span>
        <span class="flag" title="English">
          <a lang="en-US" href="/?l=en">English</a>
        </span>
        <span class="flag" title="Español">
          <a lang="es-SP" href="/?l=es">Español</a>
        </span>
        <span class="flag" title="Français">
          <a lang="fr-FR" href="/?l=fr">Français</a>
        </span>
      </div>
      <div class="recommendations">
        <a href="https://getfirefox.com">
          <img src="assets/firefox-logo.svg" i18n-alt="Description of the Firefox logo for the action in the footer@@app.firefox.logo" alt="Firefox logo" />
          <span i18n="Link to download Firefox in the footer@@app.firefox.action">Download Firefox</span>
        </a>
        <a href="https://discord.gg/VTBjxn7">
          <img src="assets/discord-logo-white.svg" i18n-alt="Description of the Discord logo for the action in the footer@@app.discord.logo" alt="Discord logo" />
          <span i18n="Link to join Discord in the footer@@app.discord.action">Chat with us on Discord</span>
        </a>
      </div>
    </div>
  </footer>
</div>
